<template>
  <div id="list">
    <v-row>
      <v-col>
        <v-text-field
          v-model="searchForm"
          label="Hľadať"
          class="ma-2"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <search-forms-component
          :search-form="searchForm"
          :get-items-function="getItemsCra"
          :delete-item-function="deleteItemCra"
          get-item="crcra_uvod"
          form-name="CRA"
        />
      </v-col>
      <v-col>
        <search-forms-component
          :search-form="searchForm"
          :get-items-function="getItemsIapsz"
          :delete-item-function="deleteItemIapsz"
          get-item="iapsz_udaje_o_klientovi"
          form-name="IAPSZ"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <search-forms-component
          :search-form="searchForm"
          :get-items-function="getItemsGeneralZavislostiPred"
          :delete-item-function="deleteItemGeneralZavislostiPred"
          get-item="general_zavislosti_pred"
          form-name="ŠRaVVP Závislosti pred"
        />
      </v-col>

      <v-col>
        <search-forms-component
          :search-form="searchForm"
          :get-items-function="getItemsGeneralZavislostiPo"
          :delete-item-function="deleteItemGeneralZavislostiPred"
          get-item="general_zavislosti_po"
          form-name="ŠRaVVP Závislosti po"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <search-forms-component
          :search-form="searchForm"
          :get-items-function="getItemsGeneralSkalyPred"
          :delete-item-function="deleteItemGeneralSkalyPred"
          get-item="general_skaly_pred"
          form-name="ZRaVVP vstup. hodnotenie"
        />
      </v-col>

      <v-col>
        <search-forms-component
          :search-form="searchForm"
          :get-items-function="getItemsGeneralSkalyPo"
          :delete-item-function="deleteItemGeneralSkalyPred"
          get-item="general_skaly_po"
          form-name="ZRaVVP výstup. hodnotenie"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6">
        <search-forms-component
          :search-form="searchForm"
          :get-items-function="getItemsGeneralTesty"
          :delete-item-function="deleteItemGeneralTesty"
          get-item="general_testy"
          form-name="Testy"
        />
      </v-col>
    </v-row>
  </div>
</template>


<script>
import { APIService } from "@/http/APIService.js";
const apiService = new APIService();

import SearchFormsComponent from "./SearchComponent.vue";

export default {
  components: {
    "search-forms-component": SearchFormsComponent,
  },
  data: () => ({
    searchForm: "",
  }),

  methods: {
    getItemsIapsz(sort, search, limit, offset, filter_key, filter_value) {
      return apiService.getIapszForms(
        sort,
        search,
        limit,
        offset,
        filter_key,
        filter_value
      );
    },
    deleteItemIapsz(item) {
      return apiService.deleteIapszForm(item);
    },

    getItemsCra(sort, search, limit, offset, filter_key, filter_value) {
      return apiService.getCraForms(
        sort,
        search,
        limit,
        offset,
        filter_key,
        filter_value
      );
    },
    deleteItemCra(item) {
      return apiService.deleteCraForm(item);
    },

    getItemsGeneralSkalyPred(
      sort,
      search,
      limit,
      offset,
      filter_key,
      filter_value
    ) {
      return apiService.getGeneralSkalyPredForms(
        sort,
        search,
        limit,
        offset,
        filter_key,
        filter_value
      );
    },
    deleteItemGeneralSkalyPred(item) {
      return apiService.deleteSkalyPred(item);
    },
    getItemsGeneralSkalyPo(
      sort,
      search,
      limit,
      offset,
      filter_key,
      filter_value
    ) {
      return apiService.getGeneralSkalyPoForms(
        sort,
        search,
        limit,
        offset,
        filter_key,
        filter_value
      );
    },
    deleteItemGeneralSkalyPo(item) {
      return apiService.deleteSkalyPo(item);
    },

    getItemsGeneralZavislostiPred(
      sort,
      search,
      limit,
      offset,
      filter_key,
      filter_value
    ) {
      return apiService.getGeneralZavislostiPredForms(
        sort,
        search,
        limit,
        offset,
        filter_key,
        filter_value
      );
    },
    deleteItemGeneralZavislostiPred(item) {
      return apiService.deleteGeneralZavislostiPred(item);
    },
    getItemsGeneralZavislostiPo(
      sort,
      search,
      limit,
      offset,
      filter_key,
      filter_value
    ) {
      return apiService.getGeneralZavislostiPoForms(
        sort,
        search,
        limit,
        offset,
        filter_key,
        filter_value
      );
    },
    deleteItemGeneralZavislostiPo(item) {
      return apiService.deleteGeneralZavislostiPo(item);
    },

    getItemsGeneralTesty(
      sort,
      search,
      limit,
      offset,
      filter_key,
      filter_value
    ) {
      return apiService.getGeneralTestyForms(
        sort,
        search,
        limit,
        offset,
        filter_key,
        filter_value
      );
    },
    deleteItemGeneralTesty(item) {
      return apiService.deleteGeneralTestyForm(item);
    },
  },
};
</script>